module.exports = __webpack_public_path__ + "static/media/acri-st.848ec896.png";